import styled from "styled-components";
import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import pages from "../../constants/pages";
import Preview from "../../assets/ad.png";
import Sprintex from "../../assets/Sprintex.png";
import { colors } from "../css components/Style";
import { useAxios, useComponent } from "../../hooks";
import { alert } from "../../redux/slices/alertSlice";
import { CancelButton, PrimaryButton } from "../css components/Button";
import { signOutMember } from "../../redux/slices/memberSlice";
import WelcomeCards from "./login user components/WelcomeCards";

const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

const ImageDiv = styled.div`
  width: 100%;
  display: flex;
  text-align: center;
  justify-content: center;
`;

const Image = styled.img`
  width: 240px;
  padding: 80px 20px;
`;

const QuoteBox = styled.div`
  margin: auto 20px;
  color: white;
`;

const AdImage = styled.div`
  position: absolute;
  bottom: 0;
  display: flex;
  text-align: end;
  justify-content: end;
  width: 100%;
`;

export default function WelcomeUnverified() {
  const axios = useAxios();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loader } = useComponent();

  const [steps, setStep] = useState({});
  const [status, setStatus] = useState(false);
  const [verification, setVerification] = useState({
    brand: false,
    admin: false,
  });
  const userID = sessionStorage.getItem("userID");
  const brandID = sessionStorage.getItem("brandID");
  const role = sessionStorage.getItem("role");

  const { parentState } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    axios({
      url: "/user/info?userId=" + userID,
      disableRedirect: true,
    }).then((res) => {
      if (res.status) {
        sessionStorage.setItem("ladder", JSON.stringify(res.data?.steps));
        setStep(res.data.steps);
        if (parseInt(res.data.brand?.brand_id) === parseInt(brandID)) {
          if (res.data.brand?.is_brand_verified === 1) {
            setVerification({
              brand: true,
            });
          }
          if (res.data.brand?.is_brand_verified === 2) {
            dispatch(
              alert({
                type: "info",
                message: "Brand has been rejected by the admin!",
              })
            );
            dispatch(signOutMember());
            navigate(pages.signIn.route);
          }
        }
      }
    });
  }, [axios, userID, loader, dispatch, navigate, brandID]);

  function checkStatus() {
    setStatus(true);
    axios({
      url: "/user/info?userId=" + userID,
      disableRedirect: true,
    }).then((res) => {
      if (res.status) {
        if (parseInt(res.data.brand?.brand_id) === parseInt(brandID)) {
          if (res.data.brand?.is_brand_verified === 0) {
            let message = "Brand hasn't been approved by the admin yet!";

            if (
              !res.data.brand?.get_agreement ||
              !res.data.brand?.sign_agreement
            ) {
              message = "Agreement process is pending from your side";
            }

            dispatch(
              alert({
                type: "warning",
                message: message,
              })
            );
          }

          if (res.data.brand?.is_brand_verified === 1) {
            setVerification({
              brand: true,
            });

            dispatch(
              alert({
                type: "success",
                message: "Brand has been approved by the admin!",
              })
            );
          }

          if (res.data.brand?.is_brand_verified === 2) {
            dispatch(
              alert({
                type: "info",
                message: "Brand has been rejected by the admin!",
              })
            );
            dispatch(signOutMember());
            navigate(pages.signIn.route);
          }
        }
        setStatus(false);
      }
    });
  }

  return (
    <Wrapper>
      <Box display="flex" height="100vh" width="100%">
        <Box
          flex="0 0 30%"
          bgcolor={colors.sprintexBlue}
          style={{ position: "relative" }}
        >
          <ImageDiv>
            <Image src={Sprintex} />
          </ImageDiv>

          <QuoteBox>
            <Typography style={{ fontSize: "25px" }}>
              Create. Target. Launch.
            </Typography>
            <Typography style={{ fontSize: "25px" }}>
              {" "}
              Your multi-channel campaigns
            </Typography>
            <Typography style={{ fontSize: "25px" }}>start here.</Typography>

            <Typography
              style={{ fontSize: "14px", marginTop: "25px", opacity: "0.8" }}
            >
              From audience to action—powerful campaigns made simple.
            </Typography>
          </QuoteBox>

          <AdImage>
            <img src={Preview} style={{ height: "250px" }} alt="!" />
          </AdImage>
        </Box>

        <Box bgcolor="white" sx={{ padding: "20px", width: "70%" }}>
          <div
            style={{
              display: "flex",
              gap: "10px",
              justifyContent: "flex-end",
            }}
          >
            {parentState === "SA" && (
              <div>
                <CancelButton
                  variant="outlined"
                  onClick={() => navigate(pages.adminWelcomePage.route)}
                >
                  Back
                </CancelButton>
              </div>
            )}

            <PrimaryButton
              style={{ float: "right" }}
              variant="outlined"
              onClick={() => dispatch(signOutMember())}
            >
              Logout
            </PrimaryButton>
          </div>

          <Typography className="who">
            Get Started with Your Brand Identity
          </Typography>

          <Typography className="choose-brand">
            Configure your brand details on Sprintexx to personalize how your
            audience experiences your campaigns.
          </Typography>

          <WelcomeCards steps={steps} verification={verification} />

          {steps.step2 && steps.step3 && !verification.brand && (
            <div className="admin-status">
              <Typography
                style={{
                  textAlign: "center",
                  fontWeight: "600",
                }}
              >
                Your {role === "AGENCY" ? "brand" : "account"} is waiting for
                the admin approval!
                <Typography
                  style={{ cursor: "pointer" }}
                  variant="button"
                  color={colors.sprintexBlue}
                  onClick={checkStatus}
                  disabled={status}
                >
                  {" "}
                  Click to check status.
                </Typography>
              </Typography>
            </div>
          )}

          {steps.step2 && steps.step3 && verification.brand && (
            <div className="admin-approve-status">
              <Typography
                style={{
                  textAlign: "center",
                  fontWeight: "600",
                }}
              >
                Your account has been approved by the admin. Click here to{" "}
                <Typography
                  style={{ cursor: "pointer" }}
                  variant="button"
                  color={colors.sprintexBlue}
                  onClick={() => {
                    dispatch(signOutMember());
                    navigate(pages.signIn.route);
                  }}
                >
                  Login
                </Typography>
              </Typography>
            </div>
          )}
        </Box>
      </Box>
    </Wrapper>
  );
}
